import * as cnt from './constants';

// export const sendRates = (payload) => { return { type: cnt.ADD_RATE, payload }; };
export const resetSelectedRate = () => ({ type: cnt.RESET_SELECTED_RATE });
export const resetSelectedLocation = () => ({ type: cnt.RESET_SELECTED_LOCATION });
export const resetRateOptions = () => ({ type: cnt.RESET_SELECTED_ALL });
export const sendRates = (payload) => ({ type: cnt.SEND_RATES, payload });
export const sendRateRequest = (payload) => ({ type: cnt.SEND_RATE_REQUESTS, payload });
export const sendMessage = (payload) => ({ type: cnt.SEND_MESSAGE, payload });
export const resetSelectedContractRequest = () => ({ type: cnt.RESET_CONTRACTING_REQUEST });



// WEBPACK FOOTER //
// ./src/app/components/partner-details/__store__/actions.js